<div *ngIf="showProjectInfo && anfrage" class="information-card">
    <h4 class="project-title">{{title}}</h4>
    <main>
        <div class="information-card">
            <review-project-overview [form]="reviewForm" [attachmentsForm]="attachmentProcessStepForm" [review]="review"></review-project-overview>
        </div>
    </main>
</div>